/**
 * 获取Link组件的href值，方便线上测试
 */
export default (path: string) => {
  const prefixer = process.env.NODE_ENV === 'production' ? '' : ''
  // const prefixer = '/test'
  return prefixer + path
}
